import React, {useEffect, useState} from "react";
// import styled from "styled-components";
import {Button, CardHeader} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

import {store} from "../store";
import CardConnectTokenizer from "../CardConnectTokenizer";
import Amex from "../svg/Amex";
import Visa from "../svg/Visa";
import Mastercard from "../svg/Mastercard";
import Discover from "../svg/Discover";
// import StyledBalanceReload from "../styles/BalanceReload";

const useStyles = makeStyles({
    root: {
        background: "#6BD19A",
        marginTop: "10px",
        border: 0,
        borderRadius: 3,
        // boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
        color: "white",
        height: 48,
        padding: "0 30px",
        "&:hover": {
            background: "#1DC26A",
        },
    },
});

const Payment = () => {
    const [token, setToken] = useState(false);
    // const [error, setError] = useState(true);
    // const [showError, setShowError] = useState(false);
    // const [isValid, setIsValid] = useState(false);
    const [processing, setProcessing] = useState(false);
    const buttonStyles = useStyles();

    const globalState = React.useContext(store);
    const {setState: setGlobalState} = globalState;
    const {amount, env} = globalState.state;
    const accountNumber = globalState.state.account.number;
    let tokenUrl = 'https://fts.cardconnect.com';
    let url = 'https://www.firsttowndowntown.org/giftcards/index.php/action/add';

    if (env === 'dev') {
        tokenUrl = 'https://fts-uat.cardconnect.com';
        // url = `https://www.firsttowndowntown.org/giftcards/index.php/action/add`;
        url = 'http://localhost:9000/action/add'
    }

    useEffect(() => {
        window.addEventListener("message", onEvent, false);
        return () => window.removeEventListener("message", onEvent);
    });

    const onEvent = event => {
        if (event.origin === tokenUrl) {
            let token = JSON.parse(event.data);
            let mytoken = document.getElementById("ftdt-reload-token");
            mytoken.value = token.message;

            if (token.validationError) {
                setToken(false);
            }

            if (token.message) {
                setToken(token.message);
                // setError(false);
            }
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        if (token) {
            setProcessing(true);
            const tl = token.length;
            const al = accountNumber.length;

            const urlToken =
                token.slice(0, 5) +
                accountNumber.slice(0, 8) +
                token.slice(5) +
                accountNumber.slice(8) +
                tl +
                al;

            const formData = new FormData();
            formData.append("token", urlToken);
            formData.append("amount", amount * 100);

            const result = await fetch(url, {
                method: "post",
                body: formData,
            }).then(resp => {
                setProcessing(false);
                return resp.json();
            });

            if (result.data.status === "success") {
                setGlobalState({
                    _path: "account.balance",
                    _value: result.data.balance,
                });
                setGlobalState({_path: "amount", _value: 0});
                setGlobalState({_path: "progress", _value: "complete"});
            }

            if (result.data.status === "error") {
                setGlobalState({_path: "progress", _value: "failed"});
            }
        }
    };

    const goBack = e => {
        e.preventDefault();

        setGlobalState({_path: "progress", _value: "amount"});
        setGlobalState({_path: "amount", _value: 0});
    };

    const submitDisabled = () => {
        if (!token) {
            return true;
        }

        if (processing) {
            return true;
        }

        return false;
    };

    return (
        <React.Fragment>
            <div style={{textAlign: "left", width: "100%", fontSize: "10px"}}>
                <button onClick={goBack}>&laquo; Back</button>
            </div>
            <CardHeader
                title="Payment Source"
                subheader="We accept all major credit cards."
            />
            <div style={{marginBottom: "10px"}}>
                <Amex/>&nbsp;
                <Discover/>&nbsp;
                <Visa/>&nbsp;
                <Mastercard/>&nbsp;
            </div>
            <form name="tokenform" id="tokenform">
                <div
                    style={{
                        padding: "15px",
                        backgroundColor: "#EAEAEA",
                        // marginBottom: "20px",
                        borderTop: "4px solid #bbb",
                    }}
                >
                    <CardConnectTokenizer/>
                </div>
                <input type="hidden" name="token" id="ftdt-reload-token"/>
                <Button
                    disabled={submitDisabled()}
                    variant="contained"
                    onClick={handleSubmit}
                    className={buttonStyles.root}
                >
                    Pay
                </Button>
            </form>
        </React.Fragment>
    );
};

export default Payment;
